import { TypeCompiler } from '@sinclair/typebox/compiler';

import { DayOfWeekInstanceSchedule } from '../schema/day-of-week-instance-schedule.schema';

export const DayOfWeekInstanceScheduleValidator = TypeCompiler.Compile(
  DayOfWeekInstanceSchedule,
);
